import { combineEpics } from 'redux-observable';
import { loginUser, resetPassword } from './login/user.epic';

export const rootUserEpics = combineEpics(
  loginUser,
  resetPassword,
);
